import { useState } from "react";
import AppShell from "../components/ui/AppShell";
import SectionHeader from "../components/ui/SectionHeader";
import BottomNav from "../components/ui/BottomNav";
import { detailedRateCards } from "../data/ratecards";

function CustomerRateCard() {
  const [selectedKey, setSelectedKey] = useState(detailedRateCards[0]?.key || "");

  const selectedCard =
    detailedRateCards.find((item) => item.key === selectedKey) || detailedRateCards[0];

  return (
    <AppShell maxWidth="1100px">
      <SectionHeader
        title="Detailed Customer Rate Cards"
        subtitle="Structured reference pricing by service family. Final pricing should still come from backend rules."
      />

      <div style={selectorWrap}>
        {detailedRateCards.map((card) => {
          const active = selectedKey === card.key;

          return (
            <button
              key={card.key}
              onClick={() => setSelectedKey(card.key)}
              style={{
                ...selectorBtn,
                background: active ? "#fff" : "#111",
                color: active ? "#000" : "#fff",
              }}
            >
              {card.title.replace(" Detailed Rate Card", "")}
            </button>
          );
        })}
      </div>

      <div style={noteBox}>{selectedCard.note}</div>

      <div style={{ display: "grid", gap: "18px" }}>
        {selectedCard.sections.map((section) => (
          <div key={section.title} style={sectionCard}>
            <div style={sectionHeader}>{section.title}</div>

            <div style={tableHeader}>
              <div>Description</div>
              <div>Price</div>
            </div>

            {section.items.map((item) => (
              <div key={item.name} style={tableRow}>
                <div>{item.name}</div>
                <div style={{ fontWeight: "bold" }}>{item.price}</div>
              </div>
            ))}
          </div>
        ))}
      </div>

      <BottomNav />
    </AppShell>
  );
}

const selectorWrap = {
  display: "flex",
  gap: "10px",
  flexWrap: "wrap",
  marginBottom: "18px",
};

const selectorBtn = {
  padding: "10px 14px",
  border: "1px solid #2a2a2a",
  borderRadius: "999px",
  cursor: "pointer",
  fontWeight: "bold",
};

const noteBox = {
  background: "#dfe4ef",
  color: "#111",
  padding: "18px 20px",
  borderRadius: "12px",
  lineHeight: "1.8",
  marginBottom: "20px",
  fontWeight: "bold",
};

const sectionCard = {
  background: "#111",
  border: "1px solid #222",
  borderRadius: "16px",
  overflow: "hidden",
};

const sectionHeader = {
  background: "#171717",
  color: "#fff",
  padding: "18px 20px",
  fontSize: "18px",
  fontWeight: "bold",
};

const tableHeader = {
  display: "grid",
  gridTemplateColumns: "1.7fr 0.8fr",
  padding: "14px 20px",
  borderTop: "1px solid #2a2a2a",
  borderBottom: "1px solid #2a2a2a",
  fontWeight: "bold",
  background: "#0f0f0f",
};

const tableRow = {
  display: "grid",
  gridTemplateColumns: "1.7fr 0.8fr",
  padding: "14px 20px",
  borderBottom: "1px solid #222",
  color: "#d1d1d1",
  lineHeight: "1.7",
};

export default CustomerRateCard;